import { render, staticRenderFns } from "./PageMiniGamesStart.vue?vue&type=template&id=2abc1aab&scoped=true&"
import script from "./PageMiniGamesStart.vue?vue&type=script&lang=js&"
export * from "./PageMiniGamesStart.vue?vue&type=script&lang=js&"
import style0 from "./PageMiniGamesStart.vue?vue&type=style&index=0&id=2abc1aab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abc1aab",
  null
  
)

export default component.exports